export default "__VITE_ASSET__308d8f03__"